import { LocationIcon, PersonIcon, StartIcon, TreesIcon } from '@/assets';
import { TabRoute } from '@/navigation/types/navigation';
import type { SVGComponent } from '@/types';

type TabIconConfig = {
  icon: SVGComponent;
  /** Material icons take `fill`, our custom SVGs take `color`. */
  colorProp: 'fill' | 'color';
};

/**
 * Single source of truth for the four bottom-tab icons. Consumed by both the
 * real BottomTabbar (via TabRouting) and the tour's decorative TourTabBar, so
 * a change to the tab iconography stays a one-file edit.
 */
export const TAB_ICONS: Record<TabRoute, TabIconConfig> = {
  [TabRoute.Start]: { icon: StartIcon, colorProp: 'fill' },
  [TabRoute.Radio]: { icon: LocationIcon, colorProp: 'fill' },
  [TabRoute.Region]: { icon: TreesIcon, colorProp: 'color' },
  [TabRoute.Profile]: { icon: PersonIcon, colorProp: 'fill' }
};

export const renderTabIcon = (
  route: TabRoute,
  { color, size }: { color: string; size: number }
) => {
  const { icon: Icon, colorProp } = TAB_ICONS[route];
  return <Icon {...{ [colorProp]: color }} width={size} height={size} />;
};
